@for (edito of storyBehind; track trackByFn($index, edito)) {
<div>
    <h-story-behind-edito [edito]="edito"></h-story-behind-edito>
</div>
}
